import { IApplicationContext } from '~/common/types';

export const applyTheme = (userTheme: IApplicationContext['userTheme']) => {
  const rootElement = document.querySelector(':root') as HTMLElement;
  if (rootElement) {
    // bg
    rootElement.style.setProperty(
      '--falcon-body-bg',
      String(userTheme.platformBackgroundColor ?? ''),
    );
    rootElement.style.setProperty(
      '--falcon-bg-navbar-glass',
      String(userTheme.platformBackgroundColor ?? ''),
    );
    // primary color: button/menu bg
    rootElement.style.setProperty(
      '--falcon-primary',
      String(userTheme.primaryColor ?? ''),
    );
    rootElement.style.setProperty(
      '--primary-color',
      String(userTheme.primaryColor ?? ''),
    );
    // title text
    rootElement.style.setProperty(
      '--title-text-color',
      String(userTheme.textColorActive ?? ''),
    );
    // description text
    rootElement.style.setProperty(
      '--paragraph-text-color',
      String(userTheme.subtitleColor ?? ''),
    );
    // menu item color
    rootElement.style.setProperty(
      '--menu-item-text-color',
      String(userTheme.textColorInactive ?? ''),
    );
    // menu item color hover/active
    rootElement.style.setProperty(
      '--menu-item-hover-color',
      String(userTheme.primaryTextColor ?? ''),
    );
    // primary button text color
    rootElement.style.setProperty(
      '--primary-btn-color',
      String(userTheme.primaryTextColor ?? ''),
    );
    // wizard active text color
    rootElement.style.setProperty(
      '--wizard-active-color',
      String(userTheme.primaryTextColor ?? ''),
    );
  }
};
